import { AxiosInstance } from "./axios";

export const getForm = async (id)=>{
    const form = await AxiosInstance.get(`/forms/${id}`)
    return form.data;
}